export interface ApiBlockedE164Number {
  AccountId: string;
  BlockedE164NumberId: string;
  E164Number: string;
  OrganizationId: string;
}

export interface BlockedE164Number {
  accountId: string;
  blockedE164NumberId: string;
  e164Number: string;
  organizationId: string;
}

export function ApiBlockedE164NumberToBlockedE164Number(
  apiBlockedE164Number: ApiBlockedE164Number
): BlockedE164Number {
  return {
    accountId: apiBlockedE164Number.AccountId,
    blockedE164NumberId: apiBlockedE164Number.BlockedE164NumberId,
    e164Number: apiBlockedE164Number.E164Number,
    organizationId: apiBlockedE164Number.OrganizationId
  };
}
